export default {
  namespaced: true,
  share_video_link: {
    title: "compartilhar link do vídeo",
    modal_title: "é necessária senha para visualizar o vídeo",
    password: "senha",
    password_error: "senha incorreta",
    expired_link: "link de vídeo expirado",
  },
}
